import React from "react";
import ReactGA from "react-ga";
import { useLocation } from "react-router-dom";

import { schemaEVR as schema } from "csv-package";
import ApplicationFrame from "../../../components/ApplicationFrame";

import Complete from "../components/Complete";
import ReDeclare from "../components/ReDeclare";
import ReDeclareComplete from "../components/ReDeclareComplete";

import steps from "../steps";

const ApplicationEVR: React.FC = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    ReactGA.pageview(pathname);
  }, [pathname]);

  return (
    <ApplicationFrame
      schema={schema}
      steps={steps}
      complete={<Complete />}
      reDeclare={<ReDeclare />}
      reDeclareComplete={<ReDeclareComplete />}
      compatibleTypes={["E", "V", "R", "EV", "EVR"]}
      narrativeLimitConfig={{
        keys: [
          "incident_fsw_detail",
          "app_type_extend_why_breached",
          "app_type_extend_why_violence_stopped",
        ],
        limit: 3000,
        step: 3,
      }}
    />
  );
};

export default ApplicationEVR;
